<template>
    <div>
        <template v-for="( key, index ) in headers">
            <span
                class="table__body__row__text"
                :class="`table__${model}__col__${index}`"
                :key="index"
            >
                <template v-if="[ 'id', 'beginDate' ].includes( key )" >
                    {{ row[key] }}
                </template>
                <template v-else-if="[ 'state' ].includes( key )" >
                    {{ row[key].name }}
                </template>
                <template v-else-if="[ 'operator' ].includes( key )" >
                    {{ firstLastWords( row[key].name ) }}
                </template>
                <template v-else-if="key === 'observations'" >
                    <div
                        class="call__table__observations__container svg--parent"
                        @mouseenter="observation.text.show = true"
                        @mouseleave="observation.text.show = false"
                    >
                        <div class="position--relative">
                            <icon-info
                                v-if="row[key]"
                                class="pointer"
                            />
                            <tooltip
                                v-show="observation.coppied"
                                class="call__table__observations__tooltip"
                                direction="right"
                                v-html="$t('global.coppied')"
                            />
                        </div>
                        <div
                            v-show="observation.text.show"
                            class="call__table__observations pointer call__table__observations__scroll"
                            :class="{ 'call__table__observations--show': observation.text.show }"
                            @click="copyToClipboard(row[key])"
                        >
                            {{ row[key] }}
                        </div>
                    </div>
                </template>
                <template v-else-if="key === 'audio'">
                    <base-audio
                        v-if="row.audioUrl"
                        :settings="{
                            id: row.id,
                            requestId: $route.params.id,
                            model: $route.meta.api
                        }"
                    />
                    <template v-else>---</template>
                </template>
                <template v-else >
                    <base-button
                        v-if="key === 'details'"
                        type="button"
                        class="table__body__row__text__button background--transparent color--green accessibility--button"
                        :customClass="true"
                        :hasHover="false"
                        @click="action({ callId: row.id, audioUrl: row.audioUrl })"
                        @keydown.enter="action({ callId: row.id, audioUrl: row.audioUrl })"
                        v-html="$t('global.seeDetails')"
                    />
                    <template v-else >
                        ---
                    </template>
                </template>
            </span>
        </template>
        <input id="observation" type="hidden" :value="observation.value">
    </div>
</template>

<script>
// package
import { reactive } from '@vue/composition-api';

// hooks
import copy from '@/hooks/use-copy';

// utils
import { firstLastWords } from '@/utils/';

export default {
    components: {
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' ),
        IconInfo: () => import( /* webpackChunkName: 'IconInfo' */ '@/components/bundles/layout/images/icons/IconInfo' ),
        Tooltip: () => import( /* webpackChunkName: 'Tooltips' */ '@/components/bundles/tooltips/Tooltip' ),
        BaseAudio: () => import( /* webpackChunkName: 'BaseAudio' */ '@/components/bundles/players/audio/Audio' )
    },
    props: {
        headers: Array,
        row: Object,
        model: String,
        action: Function
    },
    setup () {
        // comportamento da tooltip das observações
        const observation = reactive({
            value: null,
            text: {
                show: false
            },
            tooltip: {
                show: false,
                label: 'clickToCopy',
                class: 'big'
            },
            coppied: false
        });

        // copiar a observação para o clipboard
        const copyToClipboard = value => {
            observation.value = value;
            copy( document.getElementById( 'observation' ) );

            // troca a label da tooltip
            observation.coppied = true;
            observation.tooltip.class = 'small';

            // passado 1 segundo e meio volta
            setTimeout( () => {
                observation.coppied = false;
            }, 600 );
        };
        return {
            observation,
            copyToClipboard,
            firstLastWords
        };
    }
};
</script>
<style lang="scss">
.call {
    &__table {
        &__observations {
            @include elements-colors( $color-green, $color-white );
            @include animation( slide-in-top-center .26s cubic-bezier( .0, .0, .2, 1 ) );
            position: absolute;
            top: 40px;
            padding: 20px;
            @include rounded-corner( 15px );
            opacity: 0;
            @include transform-position( false, false, false, 50%, translateX( -50% ) );
            @include transition( width .3s ease-in-out );
            z-index: 20;
            width: 55%;
            height: 270px;
            overflow-y: auto;
            box-shadow: 0px 2px 4px 1px $bg-light;
            &--show {
                opacity: 1;
            }
            &__container {
                width: 55px;
                padding-left: 25px;
                margin-left: -25px;
            }
            &__scroll {
                &::-webkit-scrollbar {
                    width: 9px;  /* for vertical scrollbars */
                }
                &::-webkit-scrollbar-track {
                    margin: 10px 0 10px 0;
                    background: $color-green;
                    @include rounded-corner( 9px );
                }
                &::-webkit-scrollbar-thumb {
                    background: $color-white;
                    @include rounded-corner( 9px );
                    @include element-border( rgba(0, 0, 0, 0), 2px, solid );
                    background-clip: padding-box;
                }
            }
            &__tooltip {
                margin-left: 7px;
            }
        }
    }
}
</style>